import { Product } from '../types';

export const products: Product[] = [
  {
    id: '1',
    name: 'Organic Quinoa',
    description: 'Premium organic quinoa, a complete protein source rich in nutrients and fiber.',
    price: 12.99,
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1612358405970-e1adb2e8bf09?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'organic-foods',
    amazonLink: 'https://www.amazon.com/dp/B00JPJQZSK',
    healthScore: 95,
    ingredients: ['100% Organic Quinoa'],
    benefits: ['High in protein', 'Contains all 9 essential amino acids', 'Rich in fiber'],
    tags: ['organic', 'gluten-free', 'vegan', 'non-gmo']
  },
  {
    id: '2',
    name: 'Plant-Based Protein Powder',
    description: 'Clean, plant-based protein powder with no artificial ingredients.',
    price: 29.99,
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1593095948071-474c5cc2989d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'natural-supplements',
    amazonLink: 'https://www.amazon.com/dp/B00NBIWHP0',
    healthScore: 92,
    ingredients: ['Pea Protein', 'Brown Rice Protein', 'Hemp Protein', 'Natural Flavors'],
    benefits: ['20g protein per serving', 'Easy to digest', 'No artificial sweeteners'],
    tags: ['vegan', 'non-gmo', 'gluten-free', 'soy-free']
  },
  {
    id: '3',
    name: 'Natural Face Moisturizer',
    description: 'Hydrating face cream made with clean, natural ingredients.',
    price: 24.95,
    rating: 4.6,
    image: 'https://images.unsplash.com/photo-1556229010-6c3f2c9ca5f8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'clean-beauty',
    amazonLink: 'https://www.amazon.com/dp/B01M4MCUAF',
    healthScore: 90,
    ingredients: ['Aloe Vera', 'Shea Butter', 'Jojoba Oil', 'Vitamin E'],
    benefits: ['Deeply hydrating', 'Non-greasy formula', 'For all skin types'],
    tags: ['paraben-free', 'cruelty-free', 'fragrance-free']
  },
  {
    id: '4',
    name: 'Eco-Friendly Bamboo Towels',
    description: 'Sustainable bamboo towels that are soft, absorbent, and eco-friendly.',
    price: 34.99,
    rating: 4.5,
    image: 'https://images.unsplash.com/photo-1583845112203-29329902332e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'eco-friendly-home',
    amazonLink: 'https://www.amazon.com/dp/B07DFDMGB3',
    healthScore: 88,
    benefits: ['Naturally antimicrobial', 'Highly absorbent', 'Sustainable material'],
    tags: ['eco-friendly', 'biodegradable', 'chemical-free']
  },
  {
    id: '5',
    name: 'Organic Nut & Seed Bar',
    description: 'Nutritious snack bars made with organic nuts, seeds, and dried fruits.',
    price: 16.99,
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1582693694074-ed8c08b0b3f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'healthy-snacks',
    amazonLink: 'https://www.amazon.com/dp/B07DWVL7Y1',
    healthScore: 93,
    ingredients: ['Almonds', 'Cashews', 'Pumpkin Seeds', 'Dates', 'Coconut Oil'],
    benefits: ['Good source of protein', 'High in healthy fats', 'No added sugars'],
    tags: ['organic', 'gluten-free', 'vegan', 'paleo']
  },
  {
    id: '6',
    name: 'Plant-Based Burger Mix',
    description: 'Delicious plant-based burger mix made from clean, whole food ingredients.',
    price: 9.99,
    rating: 4.4,
    image: 'https://images.unsplash.com/photo-1520072959219-c595dc870360?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'plant-based-foods',
    amazonLink: 'https://www.amazon.com/dp/B07KLQVZK1',
    healthScore: 87,
    ingredients: ['Black Beans', 'Quinoa', 'Sweet Potato', 'Flax Seeds', 'Spices'],
    benefits: ['High in protein', 'Good source of fiber', 'No artificial preservatives'],
    tags: ['vegan', 'non-gmo', 'soy-free']
  },
  {
    id: '7',
    name: 'Organic Green Tea',
    description: 'Premium organic green tea leaves with antioxidant properties.',
    price: 14.99,
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1627435601361-ec25f5b1d0e5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'organic-foods',
    amazonLink: 'https://www.amazon.com/dp/B00IOZWC2M',
    healthScore: 96,
    ingredients: ['100% Organic Green Tea Leaves'],
    benefits: ['Rich in antioxidants', 'Supports metabolism', 'Natural source of caffeine'],
    tags: ['organic', 'non-gmo', 'fair-trade']
  },
  {
    id: '8',
    name: 'Natural Vitamin D3 Supplement',
    description: 'Plant-based vitamin D3 supplement for immune support.',
    price: 19.95,
    rating: 4.6,
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'natural-supplements',
    amazonLink: 'https://www.amazon.com/dp/B07PZHWM5C',
    healthScore: 91,
    ingredients: ['Vitamin D3 (from lichen)', 'Organic Olive Oil', 'Vegetable Cellulose'],
    benefits: ['Supports immune function', 'Promotes bone health', 'Helps with calcium absorption'],
    tags: ['vegan', 'non-gmo', 'gluten-free']
  },
  {
    id: '9',
    name: 'Natural Deodorant',
    description: 'Aluminum-free natural deodorant that actually works.',
    price: 12.99,
    rating: 4.5,
    image: 'https://images.unsplash.com/photo-1590439471364-192aa70c0b53?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'clean-beauty',
    amazonLink: 'https://www.amazon.com/dp/B01LZYA6PW',
    healthScore: 89,
    ingredients: ['Coconut Oil', 'Shea Butter', 'Baking Soda', 'Arrowroot Powder', 'Essential Oils'],
    benefits: ['No aluminum or parabens', 'Long-lasting protection', 'Non-irritating formula'],
    tags: ['aluminum-free', 'paraben-free', 'cruelty-free']
  },
  {
    id: '10',
    name: 'Reusable Silicone Food Storage Bags',
    description: 'Eco-friendly alternative to plastic bags for food storage.',
    price: 22.99,
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1601055903647-ddf1ee9701b7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'eco-friendly-home',
    amazonLink: 'https://www.amazon.com/dp/B07GZP7BZQ',
    healthScore: 94,
    benefits: ['Plastic-free', 'Dishwasher safe', 'Leak-proof design'],
    tags: ['eco-friendly', 'plastic-free', 'bpa-free']
  },
  {
    id: '11',
    name: 'Organic Dark Chocolate',
    description: '85% cacao organic dark chocolate with minimal sugar.',
    price: 4.99,
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1606312619070-d48b4c652a52?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    category: 'healthy-snacks',
    amazonLink: 'https://www.amazon.com/dp/B005P0VJ0Y',
    healthScore: 85,
    ingredients: ['Organic Cacao', 'Organic Cacao Butter', 'Organic Coconut Sugar'],
    benefits: ['Rich in antioxidants', 'Low in sugar', 'Source of magnesium and iron'],
    tags: ['organic', 'fair-trade', 'vegan']
  },
  {
    id: '12',
    name: 'Organic Cauliflower Rice',
    description: 'Ready-to-cook organic cauliflower rice for a low-carb alternative.',
    price: 3.99,
    rating: 4.4,
    image: 'http://images.amazon.com/images/P/B09NQVXQ94.01.LZZZZZZZ.jpg',
    category: 'plant-based-foods',
    amazonLink: 'https://www.amazon.com/dp/B09NQVXQ94',
    healthScore: 88,
    ingredients: ['100% Organic Cauliflower'],
    benefits: ['Low in carbs', 'Good source of fiber', 'Versatile ingredient'],
    tags: ['organic', 'gluten-free', 'keto-friendly', 'paleo']
  }
];